/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645480225136,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"activateAmount":100.25,"stopAmount":25.0},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"PRESERVE_PROFIT","symbol":"XYZ"},
	"date": "2022-02-21T16:50:25.756-0500",
	"timestamp": "1645480225757"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) activateAmount
 * 2) stopAmount
 */
export function preserveProfitParser(pluginTemplate) {
    const parsedObject = {
        activateAmount: null,
        stopAmount: null
    }
    if(pluginTemplate) {
        parsedObject.activateAmount=pluginTemplate.activateAmount;
        parsedObject.stopAmount=pluginTemplate.stopAmount;
    }
    return parsedObject;
}